import { ChakraProvider } from "@chakra-ui/react";
import {
  AuraSelect,
  BlockedDisabledInfo,
  Address,
  AttributeDate,
  ColorPicker,
  DocumentSummary,
  ConnectedProcess,
} from "@questy/aura-cl";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { mdiAccountGroupOutline, mdiMapMarkerOutline } from "@mdi/js";
import { QueryClientProvider, useQuery } from "react-query";
import { queryClient } from ".";
import { getCommission } from "@questy/api";

interface CustomComponentProps {
  componentName: string;
  name: string;
  destinationClass: string;
  props?: { [key: string]: any };
  displayLogs?: boolean;
}

const Wraper = ({ children }: { children: any }) => (
  <QueryClientProvider client={queryClient}>
    <ChakraProvider>{children}</ChakraProvider>
  </QueryClientProvider>
);

// Specjalne obsługi dla wybranych komponentów
const CustommSelect = (props: any) => {
  const [inputValue, setInputValue] = useState("");
  return (
    <AuraSelect
      value={inputValue}
      onChange={(value) => setInputValue(value)}
      isReadOnly={false}
      icon={mdiAccountGroupOutline}
      loadDataProps={{
        titleLabel: props?.titleLabel ?? "Pokaż jeszcze więcej wyników",
        labelField: props?.labelField ?? "name",
        endpoint: props?.endpoint,
        settings: props?.settings,
      }}
      {...props}
    />
  );
};

const CustommSelectDate = (props: any) => {
  const [inputValue, setInputValue] = useState<any>();
  return (
    <AttributeDate
      value={inputValue}
      onChange={(value) => setInputValue(value)}
      {...props}
    />
  );
};

const CustomColorPicker = (props: any) => {
  const [inputValue, setInputValue] = useState<any>();
  return (
    <ColorPicker
      value={inputValue}
      onChange={(value) => setInputValue(value)}
      {...props}
    />
  );
};

const CustomConnectedProcess = (props: any) => {
  const { id } = props;
  const { data, isLoading } = useQuery<any>(
    ["customComponentConnectedProcess", {}],
    () =>
      getCommission(id, {
        extraFields: ["attributes"],
        fields: ["phaseName"],
        settings: {
          withRelations: true,
        },
      }),
    {
      enabled: true,
    }
  );

  const commissionObject = {
    id: data?.data.id,
    commissionName: data?.data.commissionNumber,
    relationName: "",
    relatedPhase: data?.data.commissionPhase,
    relatedSystemAttributes: data?.data.attributes,
    user: {
      fullName: `${data?.data?.user?.firstName} ${data?.data?.user?.lastName}`,
      avatar: data?.data?.user?.avatar,
    },
  };

  if (isLoading) return <></>;

  return (
    <ConnectedProcess
      commission={commissionObject}
      maxStages={props?.maxStages ?? 1}
      index={id}
      // TODO - obsługa odłączania procesu powiązanego
      onRemove={() => {}}
      commissionUserAvatars={[commissionObject]}
    />
  );
};

const genereComponent = (componentName: string, props: any) => {
  switch (componentName) {
    case "AuraSelect":
      return <CustommSelect {...props} />;
    case "AttributeDate":
      return <CustommSelectDate {...props} />;
    case "BlockedDisabledInfo":
      return <BlockedDisabledInfo {...props} />;
    case "Address":
      return <Address icon={mdiMapMarkerOutline} {...props} />;
    case "ColorPicker":
      return <CustomColorPicker {...props} />;
    case "DocumentSummary":
      return <DocumentSummary {...props} />;
    case "ConnectedProcess":
      return <CustomConnectedProcess {...props} />;

    default:
      break;
  }
};

const CustomScripts = () => {
  // Dane do szybkiego debugowania
  // const testProps: Array<CustomComponentProps> = [
  //   {
  //     componentName: "AuraSelect",
  //     name: "select_workers",
  //     destinationClass: "commission__reports",
  //     props: {
  //       endpoint: "account_users",
  //       isMulti: true,
  //       labelField: 'fullName',
  //       titleLabel: 'Pokaż więcej..',
  //       settings: {
  //         extra_fields: "fullName"
  //       }
  //     },
  //   },
  //   {
  //     componentName: "BlockedDisabledInfo",
  //     name: "blocked_disabled_info",
  //     destinationClass: "commission__reports",
  //     props: {
  //       label: "Zablokowana opcja",
  //     },
  //   },
  // {
  //   componentName: "Address",
  //   name: "address",
  //   destinationClass: "commission__reports",
  //   props: {
  //     label: "Stefana Żeromskiego 8, 60-544 Poznań",
  //     addressCommunity: "gmina Poznań",
  //     addressProvince: "Wielkopolska",
  //     link: "#",
  //   },
  // },
  // {
  //   componentName: "AttributeDate",
  //   name: "attribute_date",
  //   destinationClass: "commission__reports",
  //   props: {
  //     withTime: true,
  //   },
  // },
  // {
  //   componentName: "ColorPicker",
  //   name: "color_picker",
  //   destinationClass: "commission__reports",
  //   props: {},
  // },
  // {
  //   componentName: "DocumentSummary",
  //   name: "document_summary",
  //   destinationClass: "commission__reports",
  //   props: {
  //     data: {
  //       PLN: {
  //         valueNetto: "13981.8",
  //         valueVat: "54694.8",
  //         valueBrutto: "51931.61",
  //       },
  //       EUR: {
  //         valueNetto: "5746.2",
  //         valueVat: "13981.8",
  //         valueBrutto: "71027.83",
  //       },
  //     },
  //   },
  // },
  // {
  //   componentName: "ConnectedProcess",
  //   name: "connected_process",
  //   destinationClass: "commission__reports",
  //   props: {
  //     id: 125,
  //     maxStages: 4,
  //   },
  //   displayLogs: true
  // },
  // ];

  useEffect(() => {
    (window as any).customComponent = (props: Array<CustomComponentProps>) => {
      //props = testProps; // Odkomenuj w przypadku debugowania

      props?.forEach((component: CustomComponentProps) => {
        const { waitElement } = (window as any)?.auraCustom;
        component?.displayLogs && console.log("CustomComponent - props", props);

        const nameClass = `customComponent-${component?.name}`;

        // Zabezpieczenie przed dublowaniem się komponentu
        if (document.querySelector(`.${nameClass}`)) return;

        if (component?.destinationClass) {
          waitElement(`.${component?.destinationClass}`).then(
            (element: any) => {
              component?.displayLogs &&
                console.log(
                  "CustomComponent - wybrane miejsce wyświetlenia komponentu:",
                  element
                );

              const container = document.createElement("div");
              container.classList.add(nameClass);
              element.after(container);

              const render: any = genereComponent(
                component.componentName,
                component.props
              );

              ReactDOM.render(<Wraper>{render}</Wraper>, container);
            }
          );
        }
      });
    };
  }, []);
  return <></>;
};

export default CustomScripts;
